exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group {\n  margin-bottom: .5em;\n  overflow: hidden; }\n  .form-group label {\n    float: left;\n    clear: both;\n    font-size: .85em;\n    color: #363636; }\n  .form-group input {\n    float: left;\n    clear: both;\n    width: 25em;\n    margin: .5em 0 .3em;\n    padding: .5em .7em;\n    font-size: .9em;\n    border: 2px solid #e0e0e0; }\n    .form-group input:focus {\n      border-color: #2CC185;\n      outline: none; }\n    .form-group input.invalid {\n      border: 2px solid #d60300;\n      background: #fff2f2; }\n  .form-group .errors {\n    min-height: 1.2em;\n    float: left;\n    clear: both;\n    color: #d60300;\n    font-size: .9em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/InputFormGroupComponent/inputFormGroup.component.scss
// module id = ./src/app/common/components/InputFormGroupComponent/inputFormGroup.component.scss
// module chunks = main